import { useState } from "react";
import CustomTable from "../../components/CustomTable";
import { formatCurrency } from "../../../../utils/CurrencyFormat";
import SearchAndFilterBar from "../../components/SearchAndFilterBar";

const PaymentHistory = () => {
  // Initial Data
  const initialData = Array.from({ length: 60 }, (_, index) => ({
    id: index + 1,
    madv: `#DV000${(index + 1).toString().padStart(2, "0")}`,
    khachhang: {
      companyImage: "/images/logo.png",
      companyName: `Công ty ${index + 1}`,
      phone: "0123 456 789",
    },
    tendv: "Đăng ký nhãn hiệu",
    ngayThanhToan: "12/11/2024 | 08:53",
    nguoiThucHien: "Đỗ Thị Thu Trang",
    soTien: formatCurrency(10000000),
    hinhThuc: index % 3 === 0 ? "Tiền mặt" : "Chuyển khoản",
    loaiHoSo:
      index % 4 === 0
        ? "Chờ duyệt"
        : index % 4 === 1
        ? "Đang xử lý"
        : index % 4 === 2
        ? "Đã hoàn thành"
        : "Đã huỷ",
    trangThai:
      index % 3 === 0
        ? "Thành công"
        : index % 3 === 1
        ? "Đang chờ"
        : "Thất bại",
  }));

  // State
  const [searchFilters, setSearchFilters] = useState({
    search_value: "",
    from_date: "",
    to_date: "",
  });
  const [filteredData, setFilteredData] = useState(initialData);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Handle Search
  const handleSearch = () => {
    const result = initialData.filter((item) => {
      const matchesSearch =
        item.madv
          .toLowerCase()
          .includes(searchFilters.search_value.toLowerCase()) ||
        item.serviceName
          .toLowerCase()
          .includes(searchFilters.search_value.toLowerCase());

      const withinDateRange = () => {
        const itemDate = new Date(
          item.creationDate.split(" | ")[0].split("/").reverse().join("-")
        );
        const fromDate = searchFilters.from_date
          ? new Date(searchFilters.from_date)
          : null;
        const toDate = searchFilters.to_date
          ? new Date(searchFilters.to_date)
          : null;

        if (fromDate && itemDate < fromDate) return false;
        if (toDate && itemDate > toDate) return false;
        return true;
      };
      return matchesSearch && withinDateRange();
    });

    setFilteredData(result);
  };

  // Columns for CustomTable
  const columns = [
    {
      key: "id",
      title: "STT",
    },
    {
      key: "madv",
      title: "Mã dịch vụ",
      render: (value) => (
        <div className="text-[#0267FF] min-w-[50px]">{value}</div>
      ),
    },
    {
      key: "khachhang",
      title: "Khách hàng",
      render: (value) => (
        <div className="flex items-center space-x-2 min-w-[200px]">
          <img
            src={value.companyImage}
            alt="Company Logo"
            className="w-[32px] h-[32px] rounded-lg object-contain"
          />
          <div className="flex flex-col whitespace-nowrap">
            <p>{value.companyName}</p>
            <p className="text-gray-500 text-sm whitespace-nowrap">
              {value.phone}
            </p>
          </div>
        </div>
      ),
    },
    {
      key: "tendv",
      title: "Tên dịch vụ",
      render: (value) => (
        <div className="whitespace-nowrap min-w-[200px]">{value}</div>
      ),
    },
    {
      key: "ngayThanhToan",
      title: "Ngày thanh toán",
      render: (value) => <div className="min-w-[180px]">{value}</div>,
    },
    {
      key: "nguoiThucHien",
      title: "Người thực hiện",
      render: (value) => <div className="min-w-[180px]">{value}</div>,
    },
    {
      key: "soTien",
      title: "Số tiền",
      render: (value) => <div className="min-w-[150px]">{value}</div>,
    },
    {
      key: "hinhThuc",
      title: "Hình thức",
      render: (value) => <div className="min-w-[120px]">{value}</div>,
    },
    {
      key: "trangThai",
      title: "Trạng thái",
      render: (value) => {
        const color =
          value === "Thành công"
            ? "bg-green-500"
            : value === "Đang chờ"
            ? "bg-orange-500"
            : "bg-red-500";
        return (
          <span
            className={`px-3 py-1 rounded-full text-white text-xs whitespace-nowrap min-w-[150px] ${color}`}
          >
            {value}
          </span>
        );
      },
    },
  ];

  return (
    <div className="py-6">
      {/* Search and Filters */}
      <SearchAndFilterBar
        searchPlaceholder="Tìm kiếm dịch vụ"
        searchValue={searchFilters.search_value}
        onSearchChange={(e) =>
          setSearchFilters({ ...searchFilters, search_value: e.target.value })
        }
        showDatePickers
        fromDatePlaceholder="Từ ngày"
        toDatePlaceholder="Đến ngày"
        onFromDateChange={(date) =>
          setSearchFilters({ ...searchFilters, from_date: date })
        }
        onToDateChange={(date) =>
          setSearchFilters({ ...searchFilters, to_date: date })
        }
        onAddClick={handleSearch}
        addButtonLabel="Tìm kiếm"
        addButtonIcon="/icons/search.svg"
      />
      {/* Custom Table */}
      <CustomTable
        data={filteredData}
        columns={columns}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setView={true}
        setEdit={true}
        basePath="/quan-ly-khach-hang/khach-hang"
      />
    </div>
  );
};

export default PaymentHistory;
